<section class="cl-section cl-section-headline" id="overview">
  <div class="container cl-container-spacing-small">
    <div class="row align-items-center">
      <div class="col"><h1>{{title()}} @if (badge()) { <span class="cl-badge cl-badge-sm cl-color-steel">{{badge()}}</span> } @if (loading()) { <i class="fas fa-spinner fa-spin cl-color-ash" style="font-size: 0.6em; vertical-align: middle" aria-hidden="true"></i> }</h1></div>
      <!-- Action slot, used by the overlays for their way back to the page underneath. -->
      <div class="col-auto"><ng-content></ng-content></div>
    </div>
  </div>
</section>
